/** 빌드 레벨에서 제거되는 mockApis stub */
export type MockResponseStep<T = unknown> = { response: T; status?: number; delay?: number };
export const registerMockAPI = () => {};
export const mockAPIsInstance = {
  isEnabled: () => false,
  setEnabled: () => {},
  getAllEntries: () => [],
  setActiveScenario: () => {},
  resetAllScenarios: () => {},
};
